import { AbstractControl, FormControl, ValidatorFn } from "@angular/forms";

export class ValidationUtils {
    static readonly qIDPattern: RegExp = /^[A-Za-z\d_.@-]{5,25}$/;
    static readonly emailPattern: RegExp = /^[a-z\d._%+-]+@[a-z\d.-]+\.[a-z]{2,4}$/;
    static readonly usaOrCanadaZipCodePattern: RegExp = /^\d{5}(?:-\d{4})?$|^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/;
    static readonly usaZipCodePattern: RegExp = /^\d{5}(?:-\d{4})?$/;
    static readonly canadaZipCodePattern: RegExp = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/;
    static readonly phoneMask = '(000) 000-0000'

    public static sanitizeQID(value: string): string {
        return value?.replace(/[^A-Za-z\d_.@-]/g, '');
    }

    public static sanitizeRemoveSymbols(value: string): string {
        return value?.replace(/[^A-Za-z\d ]/g, '');
    }

    public static checkMatchingFormField(originalField: () => FormControl): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const reTypeField = control.value;
            if (reTypeField) {
                return reTypeField === originalField().value ? null : { matchField: { value: "The values does not match!" } };
            }
        };
    }
}